import image from '../../assets/image.png';

function TrainingKitSection({ onOpenPayment }) {
  const features = [
    { 
      icon: <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" /></svg>,
      title: "40+ v Strong Payment Recovery Notices", 
      desc: "Payment Recovery Notices", 
      color: "dark" 
    },
     { 
      icon: <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" /><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" /></svg>,
      title: "Credit Control System", 
      desc: "To Safeguard Future Payments", 
      color: "dark" 
    },
    { 
      icon: <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" /></svg>,
      title: "30 Days Payment Recovery Live Recorded Video Course", 
      desc: "Recover Any Money From Anybody", 
      color: "dark" 
    },
    { 
      icon: <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" /></svg>,
      title: "20 Powerful Payment Recovery Techniques", 
      desc: "You Have Never Heard Before", 
      color: "dark" 
    },
    { 
      icon: <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" /></svg>,
      title: "3 Hours – Rapid Payment Recovery Blueprint", 
      desc: "Deep Dive", 
      color: "dark" 
    },
    { 
      icon: <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 6l3 1m0 0l-3 9a5.002 5.002 0 006.001 0M6 7l3 9M6 7l6-2m6 2l3-1m-3 1l-3 9a5.002 5.002 0 006.001 0M18 7l3 9m-3-9l-6-2m0-2v2m0 16V5m0 16H9m3 0h3" /></svg>,
      title: "Top Debt Recovery Advocates Contact Details", 
      desc: "That Works  No Recovery No Fees Model", 
      color: "dark" 
    },
    { 
      icon: <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" /></svg>,
      title: "Verified B2B Payment Recovery Agencies", 
      desc: "That Works No Recovery No Fees Model", 
      color: "dark" 
    },
    { 
      icon: <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" /></svg>,
      title: "Detective Agent Contact Details", 
      desc: "To Trace Absconding Customers", 
      color: "dark" 
    },
    { 
      icon: <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z" /></svg>,
      title: "Payment Recovery Whatsapp/ Email Scripts & Headings", 
      desc: "", 
      color: "dark" 
    },
    { 
      icon: <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z" /></svg>,
      title: "7 Days Advance Payment Collection Pre-Recorded Video Course for your Team", 
      desc: "", 
      color: "dark" 
    },
    { 
      icon: <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" /></svg>,
      title: "Cheque Bounce Control", 
      desc: "Your cheques will no longer bounce", 
      color: "dark" 
    },
   
    { 
      icon: <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 17v-2m3 2v-4m3 4v-6m2 10H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" /></svg>,
      title: "Payment Tracking Sheets & Formats", 
      desc: "", 
      color: "dark" 
    },
    { 
      icon: <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" /></svg>,
      title: "E - Credit Policy Document", 
      desc: "Ready to Use Business Policy", 
      color: "dark" 
    },
    { 
      icon: <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4" /></svg>,
      title: "Customer Background Check", 
      desc: "Verify the customer report before selling the goods", 
      color: "dark" 
    },
    { 
      icon: <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z" /></svg>,
      title: "Customer Cibil Score Check", 
      desc: "If a score is below 700 customer is not eligible for our services", 
      color: "dark" 
    },
    { 
      icon: <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15.536 8.464a5 5 0 010 7.072m2.828-9.9a9 9 0 010 12.728M5.586 15H4a1 1 0 01-1-1v-4a1 1 0 011-1h1.586l4.707-4.707C10.923 3.663 12 4.109 12 5v14c0 .891-1.077 1.337-1.707.707L5.586 15z" /></svg>,
      title: "Attend Live Sessions with Rushneek Sir", 
      desc: "Every Saturday", 
      color: "dark" 
    },
    { 
      icon: <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" /></svg>,
      title: "Dedicated Accounts Manager", 
      desc: "Always ready to help you", 
      color: "dark" 
    }
  ];

  const colorClasses = {
    dark: "from-gray-800/40 to-gray-900/40 border-gray-700/50 hover:border-purple-500 hover:shadow-purple-500/20",
    amber: "from-amber-500/20 to-amber-600/20 border-amber-500/30 hover:border-amber-400 hover:shadow-amber-500/20",
    orange: "from-orange-500/20 to-orange-600/20 border-orange-500/30 hover:border-orange-400 hover:shadow-orange-500/20",
    yellow: "from-yellow-500/20 to-yellow-600/20 border-yellow-500/30 hover:border-yellow-400 hover:shadow-yellow-500/20"
  };

  return (
    <section className="relative py-20 md:py-28 bg-gradient-to-b from-black via-gray-900 to-black overflow-hidden">

      
      {/* Background Effects */}
      <div className="absolute inset-0">
        <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-amber-500/50 to-transparent"></div>
        <div className="absolute bottom-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-amber-500/50 to-transparent"></div>
        <div className="absolute left-0 top-1/4 w-72 h-72 bg-amber-500/5 rounded-full blur-[100px]"></div>
        <div className="absolute right-0 bottom-1/4 w-96 h-96 bg-orange-500/5 rounded-full blur-[120px]"></div>
      </div>


      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Top Image */}
        

        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-3 bg-gradient-to-r from-amber-500/20 to-orange-500/20 border-2 border-amber-500/40 text-amber-400 px-8 py-4 rounded-full text-lg font-bold mb-6 backdrop-blur-md shadow-lg shadow-amber-500/20 hover:shadow-amber-500/40 hover:scale-105 transition-all duration-300 animate-pulse">
            <span className="text-3xl animate-bounce">🎁</span>
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-amber-300 via-yellow-300 to-orange-400">
              What's Included in Your Kit
            </span>
          </div>
          
          <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-black text-white mb-4">
            Be a Payment Recovery
            <br />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-amber-400 via-yellow-400 to-orange-500">
              Superstar
            </span>
          </h2>

          <div className="flex justify-center mb-10">
          <img 
            src={image} 
            alt="Training Kit" 
            className="w-64 h-auto rounded-2xl shadow-2xl shadow-amber-500/20 border border-amber-500/20"
          />
        </div>
          
          <p className="text-gray-400 text-lg max-w-2xl mx-auto">
            Everything you need to recover stuck payments and never face payment problems again
          </p>
        </div>

       

        
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 md:gap-5">
          {features.map((feature, index) => (
            <div
              key={index}
              className={`group relative bg-gradient-to-br ${colorClasses[feature.color]} rounded-2xl p-5 border backdrop-blur-sm transition-all duration-500 hover:-translate-y-2 hover:shadow-xl cursor-pointer`}
              style={{ animationDelay: `${index * 50}ms` }}
            >
              {/* Hover Glow Effect */}
              <div className="absolute inset-0 rounded-2xl bg-gradient-to-br from-white/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
              
              {/* Content */}
              <div className="relative flex items-start gap-4">
                <div className="flex-shrink-0 w-14 h-14 bg-gradient-to-br from-gray-800 to-gray-900 rounded-xl flex items-center justify-center text-white shadow-lg group-hover:scale-110 group-hover:rotate-3 transition-all duration-300 border border-gray-700">
                  {feature.icon}
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="font-bold text-white text-base group-hover:text-amber-400 transition-colors duration-300 leading-tight">
                    {feature.title}
                  </h3>
                  {feature.desc && (
                    <p className="text-gray-500 text-sm mt-1 group-hover:text-gray-400 transition-colors duration-300">
                      {feature.desc}
                    </p>
                  )}
                </div>
              </div>

              {/* Corner Accent */}
              <div className="absolute top-0 right-0 w-16 h-16 overflow-hidden rounded-tr-2xl">
                <div className="absolute top-0 right-0 w-8 h-8 bg-gradient-to-bl from-amber-500/20 to-transparent transform rotate-45 translate-x-4 -translate-y-4"></div>
              </div>
            </div>
          ))}
        </div>

       
       
      </div>
    </section>
  );
}

export default TrainingKitSection;
